<div
    class="collapse border rounded-xl"
    [ngClass]="{
        'collapse-arrow bg-gray-100 bg-opacity-25': !currentlyActive,
        'collapse-open': !collapsed,
        'collapse-close': collapsed
    }"
>
    <div class="collapse-title w-full flex flex-row items-center" (click)="toggleCollapsed()">
        <div class="flex flex-row items-center" *ngIf="!!platformLicensePricing?.effectiveFrom || !!platformLicensePricing?.effectiveTo">
            <span *ngIf="platformLicensePricing?.effectiveFrom">{{ platformLicensePricing?.effectiveFrom | date: 'dd.MM.yyyy' }}</span>
            <span>-</span>
            <span *ngIf="platformLicensePricing?.effectiveTo">{{ platformLicensePricing?.effectiveTo | date: 'dd.MM.yyyy' }}</span>
            <span *ngIf="!!platformLicensePricing?.internalDescription">:&nbsp;</span>
        </div>
        <span *ngIf="!!platformLicensePricing?.internalDescription">{{ platformLicensePricing?.internalDescription }}</span>

        <span *ngIf="currentlyActive" class="ml-3 badge badge-accent" i18n>Currently effective</span>

        <div class="flex-1"></div>
        <div class="flex flex-row items-center">
            <button class="btn btn-sm btn-circle btn-ghost" *ngIf="!editMode && editable" (click)="enableEditing()">
                <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
            </button>
            <div
                matTooltipClass="bg-iota-tooltip-bg whitespace-pre-line"
                matTooltip="This Pricing cannot be deleted"
                i18n-matTooltip
                [matTooltipDisabled]="!!platformLicensePricing?.canBeDeleted"
            >
                <button
                    class="btn btn-sm btn-circle btn-ghost btn-accent"
                    *ngIf="!editMode && editable"
                    [disabled]="!platformLicensePricing?.canBeDeleted"
                    (click)="deletePricing(); $event.stopPropagation()"
                >
                    <iota-icon icon="trash"></iota-icon>
                </button>
            </div>
            <div
                *ngIf="editMode"
                [ngClass]="{ 'tooltip tooltip-bottom': !formValid }"
                i18n-data-tip
                data-tip="Some fields are invalid or missing."
            >
                <button
                    class="btn btn-sm btn-circle btn-ghost btn-accent"
                    [disabled]="!formValid"
                    (click)="savePricing(); $event.stopPropagation()"
                >
                    <iota-icon flaticon="floppy-disk" size="1x"></iota-icon>
                </button>
            </div>
            <button class="btn btn-sm btn-circle btn-ghost btn-accent" *ngIf="editMode" (click)="cancelEditing(); $event.stopPropagation()">
                <iota-icon icon="x-mark"></iota-icon>
            </button>
        </div>
    </div>

    <div class="collapse-content w-full flex flex-col gap-5">
        <app-platform-license-pricing-form
            [platformLicense]="platformLicense"
            [platformLicensePricing]="platformLicensePricing"
            [editMode]="editMode"
            (formValid)="updateFormValidity($event)"
            #platformLicensePricingForm
        ></app-platform-license-pricing-form>
    </div>
</div>
